import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideI18n } from './core/i18n/i18n.provider';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { provideToastr, ToastNoAnimationModule } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled', // scrolls to top on new navigation
        anchorScrolling: 'enabled',           // support #anchor links
      })
    ),
    ...provideI18n(),
    // OAuth2 setup
    importProvidersFrom(OAuthModule.forRoot({
      resourceServer: {
        sendAccessToken: false,
      },
    })),
    provideAnimations(),
    importProvidersFrom(
      ToastNoAnimationModule.forRoot()
    ),
    provideToastr(), // Toastr providers
    provideCharts(withDefaultRegisterables()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
};
